import React from 'react';

import { Row as AntRow, RowProps as AntRowProps } from 'antd/lib/grid';

import { GridContext, GridContextType } from './grid';

export type RowProps = AntRowProps;

export const Row = (props: RowProps) => (
  <GridContext.Consumer>
    {(context: GridContextType) => <AntRow {...context} {...props} />}
  </GridContext.Consumer>
);
